<script>
    import { apiUrl } from "@/utils";

    export default {
        name: "ApplicationFeaturesCard",
        props: {
            feature: Object,
        },
        methods: {
            apiUrl,
        },
    };
</script>

<template>
    <div class="application-features-card">
        <div class="application-features-card__info">
            <div class="application-features-card__title">{{ feature.title }}</div>
            <div class="application-features-card__text" v-html="feature.text"></div>
        </div>

        <div class="application-features-card__image">
            <img :src="apiUrl(feature.image)" :alt="feature.title" />
        </div>
    </div>
</template>

<style lang="scss">
    .application-features-card {
        @include bp($bp-desktop-sm) {
            display: flex;
            &:hover {
                .application-features-card__image {
                    &::before {
                        opacity: 1;
                    }
                }
            }
        }
    }

    .application-features-card__info {
        padding: 0 16px;
        @include bp($bp-desktop-sm) {
            max-width: 280px;
            margin-left: 14px;
            margin-right: 10px;
            padding: 28px 0 0;
        }
    }

    .application-features-card__title {
        margin-bottom: 12px;
        color: #353535;
        font-size: 16px;
        font-weight: 700;
        line-height: 20px;
        @include bp($bp-desktop-sm) {
            font-size: 18px;
            font-weight: 600;
            line-height: 25px;
        }
    }

    .application-features-card__text {
        color: #353535;
        font-size: 14px;
        font-weight: 400;
        line-height: 28px;
        @include bp($bp-desktop-sm) {
            color: #474747;
            font-size: 16px;
            line-height: 32px;
        }
    }

    .application-features-card__image {
        img {
            position: relative;
            z-index: 2;
            max-width: 235px;
            margin: 0 auto;
        }
        @include bp($bp-desktop-md) {
            position: relative;
            &::before {
                content: "";
                position: absolute;
                top: 50%;
                left: 50%;
                width: 250px;
                height: 250px;
                background-color: #2ea7ff;
                transform: translate(-50%, -50%);
                border-radius: 50%;
                opacity: 0;
                filter: blur(120px);
                transition: opacity 0.2s ease-in;
                will-change: opacity;
            }
        }
    }
</style>
